import script from "./itemV3RemoveGroupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3RemoveGroupModal.vue?vue&type=script&setup=true&lang=ts"

import "./itemV3RemoveGroupModal.vue?vue&type=style&index=0&id=65167220&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65167220"]])

export default __exports__